import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type StoreState = {
  approvedType: 'past' | 'upcoming'
  pendingType: 'past' | 'upcoming'
}

const initialState = {
  approvedType: 'upcoming',
  pendingType: 'upcoming'
} as StoreState

export const datesStore = createSlice({
  name: 'dates',
  initialState,
  reducers: {
    setApprovedType(state, action: PayloadAction<'upcoming' | 'past'>) {
      state.approvedType = action.payload
    },
    setPendingType(state, action: PayloadAction<'upcoming' | 'past'>) {
      state.pendingType = action.payload
    }
  }
})

export const {
  setApprovedType: storeApprovedType,
  setPendingType: storePendingType
} = datesStore.actions

type DatesRoot = { dates: StoreState }

export const selectApprovedType = (state: DatesRoot) => state.dates.approvedType
export const selectPendingType = (state: DatesRoot) => state.dates.pendingType
export const datesReducer = datesStore.reducer
